/**
 * Human roles (`admin`, `user`, `curator`, `supervisor`) are trusted internal operators with
 * corpus-wide read access. There is no per-object or per-organisation policy: users and documents
 * carry no organisation, only projects do. A scoped external role must first add a
 * user-to-organisation model and one shared per-object policy helper (DR-6086).
 *
 * `service` is the machine identity for the sibling system (TRecs v2 / OIL), not a human role.
 * Its reach is the explicit allowlist in `server/src/middleware/serviceRouteAllowlist.ts` — never
 * the per-route `roles` arrays, because most write routes carry no role array at all and a
 * role-array grant would hand a machine token the whole authenticated surface. Default deny:
 * a route absent from that allowlist is forbidden for a service token even when every human role
 * may call it. Never add UI-only or destructive admin routes to it.
 */
export const roles = ["admin", "user", "supervisor", "curator", "service"];
//# sourceMappingURL=roles.js.map